import * as React from 'react';
import RawTransactionView from 'src/RawTransactionListView';

/**
 * Reconcile tab of the account detail page: the account's raw transaction
 * timeline interleaved with balance anchors. Same list as the Transactions
 * tab, but a separate workflow — reconciliation always runs over the
 * complete, unfiltered timeline, so this tab has none of the browse filters.
 */
export const AccountReconcileView = () => (
  <RawTransactionView includeProcessed mode="reconcile" />
);
